import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconCheck } from "../../../styles/assets/svg/icon_checked.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { IconBox } from "src/pages/register/Register.style";
import { useState } from "react";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ModalRegister } from "src/components/molecules/ModalRegister";
import { Terms } from "src/pages/register/components/Terms";

export const PointBoxChange = () => {
  const navi = useNavigate();
  const { state } = useLocation();
  const [toggleActive, setToggleActive] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);

  const { data: userInfo } = useUserRegister();
  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="교환하기"
          $bgColor="#fff"
          onClickArrow={() => navi(-1)}
        />

        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            marginTop: 16,
            padding: 16,
            background: "#fff",
            borderRadius: 24,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                width: "100%",
                color: "#404040",
                fontSize: 16,
                fontWeight: 500,
                lineHeight: "24px",
              }}
            >
              구매상품
            </div>

            {/* 상품 정보 */}
            <div
              style={{
                width: "100%",
                display: "flex",
                gap: 12,
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: 16,
                  overflow: "hidden",
                }}
              >
                <img
                  src={state.imgSrc}
                  alt={state.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#A3A3A3",
                  }}
                >
                  {state.title}
                </span>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: "20px",
                    color: "#404040",
                  }}
                >
                  {state.name}
                </span>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#F57C00",
                  }}
                >
                  {state.price.toLocaleString()}P
                </span>
              </div>
            </div>

            {/* 포인트 정보 */}
            <div
              style={{
                width: "100%",
                color: "#404040",
                fontSize: 16,
                fontWeight: 500,
                lineHeight: "24px",
                paddingTop: 8,
              }}
            >
              포인트 사용
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                color: "#525252",
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                gap: 8,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>보유 포인트</span>
                <span>{userInfo?.point?.toLocaleString()}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>사용</span>
                <span>-{state.price?.toLocaleString()}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: 700,
                }}
              >
                <span>잔여포인트</span>
                <span>
                  {(userInfo?.point && state.price
                    ? userInfo.point - state.price
                    : 0
                  ).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 정보 동의 */}
        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            marginTop: 16,
            padding: 16,
            background: "#fff",
            borderRadius: 24,
          }}
        >
          <div
            style={{
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              display: "flex",
            }}
          >
            <div
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "10px",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => setToggleActive(!toggleActive)}
            >
              <IconBox $isActive={toggleActive}>
                <IconCheck />
              </IconBox>
              <span
                style={{
                  color: "#404040",
                  fontSize: 14,
                  fontFamily: "Pretendard Variable",
                  fontWeight: "500",
                }}
              >
                [필수] 개인정보 수집 및 이용 동의
              </span>
            </div>
            <div
              style={{ position: "relative", cursor: "pointer" }}
              onClick={() => setModalShow(true)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.22032 5.22032C8.36094 5.07987 8.55157 5.00098 8.75032 5.00098C8.94907 5.00098 9.13969 5.07987 9.28032 5.22032L13.5303 9.47032C13.6708 9.61094 13.7497 9.80157 13.7497 10.0003C13.7497 10.1991 13.6708 10.3897 13.5303 10.5303L9.28032 14.7803C9.13814 14.9128 8.9501 14.9849 8.75579 14.9815C8.56149 14.9781 8.37611 14.8994 8.2387 14.7619C8.10128 14.6245 8.02257 14.4391 8.01914 14.2448C8.01571 14.0505 8.08784 13.8625 8.22032 13.7203L11.9403 10.0003L8.22032 6.28032C8.07987 6.13969 8.00098 5.94907 8.00098 5.75032C8.00098 5.55157 8.07987 5.36094 8.22032 5.22032Z"
                  fill="#D4D4D4"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* 하단 버튼 */}
        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            padding: 16,
            bottom: 0,
            position: "fixed",
            background: "white",
            borderTop: "1px rgba(0, 0, 0, 0.05) solid",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            boxSizing: "border-box",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <button
            style={{
              alignSelf: "stretch",
              height: 48,
              background: toggleActive ? "#F57C00" : "#FFD9B3",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontSize: 16,
              color: "white",
            }}
            onClick={() => {
              if (toggleActive) {
                navi("/point/changeList", {
                  state: { ...state, toast: "교환 완료!" },
                });
              }
            }}
          >
            교환하기
          </button>
        </div>

        {modalShow && (
          <ModalRegister
            title={"[필수] 개인정보 수집 및 이용 동의"}
            text={<Terms termsId={"personal"} />}
            toggleActive={() => setToggleActive(true)}
            setModalShow={setModalShow}
          />
        )}
      </>
    </PageContainer>
  );
};
